import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

const MakeaGame = () => {
  return (
    <div>

    <Header></Header>
    <Footer></Footer>

    </div>
  )
}

export default MakeaGame